import { NextPage, GetServerSidePropsContext } from "next";
import { ENDPOINT_CONTENT_ID } from "lib/graphql/endpoints";
import { GenericQuery } from "lib/graphql/interfaces/generic";
import { GENERIC_QUERY } from "lib/graphql/queries/generic";
import Loading from "components/Loading";
import {
    extractScript,
    replaceStyleTag,
    stringMinify,
} from "utils/StringUtils";
import getSettings from "utils/getSettings";
import dynamic from "next/dynamic";

const HtmlComponent = dynamic(() => import("components/Html/Html"));

interface IPolicyProps {
  styles: string,
  scripts: string,
  htmlpage: string,
  errorMessage: string,
  loading: boolean,
  useADA: boolean,
  adaLogo: string,
  showAdaBtnFloting: boolean,
}

const AccessibilityPage: NextPage<IPolicyProps> = ({
    styles,
    scripts,
    htmlpage,
    errorMessage,
    loading,
    // useADA,
    // adaLogo,
    // showAdaBtnFloting,
}) => {
    if (loading) return <Loading />;
    if (errorMessage) return <div>{errorMessage}</div>;

    const styleInline = replaceStyleTag(styles);
    const scriptsInline = extractScript(scripts);

    return (
        <>
            {styleInline && (
                <style jsx>{`
          ${stringMinify(styleInline)}
        `}</style>
            )}
            {scriptsInline && (
                <script>{`
            ${stringMinify(scriptsInline)}
          `}</script>
            )}
            <HtmlComponent htmlValue={htmlpage} />
        </>
    );
};

export const getServerSideProps = async ({
    res,
    req,
}: GetServerSidePropsContext) => {
    res.setHeader(
        "Cache-Control",
        `public, s-maxage=${process.env.CACHE_CONTROL_MAX}, stale-while-revalidate=${process.env.CACHE_CONTROL_MAX}`
    );
    const { client, settings } = await getSettings(req);

    const identifier = req.cookies.identifier ?? '8f32f390-3063-11ed-9036-d5acb832d43e';

    try {
        const { data, loading, error } = await client.query<GenericQuery>({
            query: GENERIC_QUERY,
            variables: {
                keyContentIds: [ENDPOINT_CONTENT_ID.ACCESIBILITY_PAGE_SETTINGS],
                websiteId: Number(process.env.WEBSITE_ID),
                identifier,
            },
            fetchPolicy: 'cache-first',
        });

        const content = data?.getWebsiteContent?.find((item) => item?.key === ENDPOINT_CONTENT_ID.ACCESIBILITY_PAGE_SETTINGS) || null;
        const json = JSON.parse(stringMinify(content?.value || ""));

        return {
            props: {
                titlePage: json.titlePage ?? 'Accessibility',
                friendlyUrl: json.friendlyUrl,
                keywords: json.keywords,
                metaDescription: json.metaDescription,
                ...json,
                errorMessage: error?.message || null,
                loading,
                settings,
            },
        };
    } catch {
        return {
            notFound: true,
        };
    }
};

export default AccessibilityPage;
